import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { trackEvent } from 'dibs-tracking';

import { ContemporaryLandingHeaderModule } from '../ContemporaryLandingHeaderModule/ContemporaryLandingHeaderModule';

const trackClick = splashHeader =>
    trackEvent({
        action: 'featured Promotion #1',
        category: 'contemporary landing page interaction',
        label: `${splashHeader.title} clicked|${splashHeader.cta}`,
    });

const ContemporaryLandingSplashHeaderModuleComponent = ({ contemporaryLandingSplashHeader }) => {
    if (!contemporaryLandingSplashHeader) {
        return null;
    }

    const { cta, imagePath, linkPath, subtitle, title } = contemporaryLandingSplashHeader;
    return (
        <ContemporaryLandingHeaderModule
            cta={cta}
            imagePath={imagePath}
            linkPath={linkPath}
            onClick={() => trackClick(splashHeader)}
            subtitle={subtitle}
            title={title}
        />
    );
};

export const ContemporaryLandingSplashHeaderModule = createFragmentContainer(
    ContemporaryLandingSplashHeaderModuleComponent,
    {
        contemporaryLandingSplashHeader: graphql`
            fragment ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader on ContemporaryLandingSplashHeader {
                ... on ContemporaryLandingSplashHeader {
                    cta
                    imagePath
                    linkPath
                    subtitle
                    title
                }
            }
        `,
    }
);

ContemporaryLandingSplashHeaderModule.propTypes = {
    ContemporaryLandingSplashHeader: PropTypes.object,
};
